import './Loader.scss';

import cn from 'classnames';
import React from 'react';

import Picture from '@/common/components/atoms/Picture/Picture';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

import LoaderGif from '../../../../../../../assets/images/scan-self-service/autosuggestion-loader.gif';

const Loader = ({ className }) => (
  <Picture
    className={cn('scan-self-service-autosuggestion-loader', className)}
    alt="Loading..."
    type="static"
    src={LoaderGif}
  />
);

Loader.defaultProps = {
  ...ClassNameDefaultProps,
};

Loader.propTypes = {
  ...ClassNamePropTypes,
};

export default Loader;
